import {
  API_DATA_SUCCESS,
  API_DATA_FAILURE,
  API_DATA_LOADING,
  LAST_BLURRED_FIELD,
  API_LOGIN_SUCCESS,
  REMOVE_NOTIFICATION,
  API_UPDATEUSER_SUCCESS
} from '../actions/constants';

const initialState = {
  isLoading: false,
  hasFailed: false,
  data: {},
  lastBlurredField: '',
  notifications: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case API_DATA_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_DATA_SUCCESS:
      let options = action.data.basket.options;
      if (action.data.basket.optionsStatus.status && action.data.basket.optionsStatus.status === 'unchanged') {
        options = state.data.options;
      }
      return { ...state, data: { ...action.data.basket, options }, notifications: action.data.notifications };
    case API_DATA_FAILURE:
      return { ...state, hasFailed: action.hasFailed, notifications: action.data.notifications || [] };
    case LAST_BLURRED_FIELD:
      return { ...state, lastBlurredField: action.field };
    case API_LOGIN_SUCCESS:
      return { ...state, notifications: action.data.notifications, data: action.data.basket };
    case REMOVE_NOTIFICATION:
      return { ...state, notifications: state.notifications.slice(1) };
    case API_UPDATEUSER_SUCCESS:
      return { ...state, notifications: action.data.notifications };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/basket_reducer.js